import React, { useState, useEffect, useRef } from 'react';
// import { OnboardingHeaderPart } from '../../header/OnboardingHeader';
import { HiVolumeUp, HiVolumeOff } from 'react-icons/hi';
import { FaPause, FaPlay } from 'react-icons/fa';
import HeaderMainPage from '../../header/HeaderMainPage';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useVoiceInput } from '../onboardingPage/VoiceInput';
import { fetchAndReturnPCM16 } from '../onboardingPage/AvatarUtils';
import { SimliClient } from "simli-client";
import { FaMicrophone, FaMicrophoneSlash, FaSpinner, FaSyncAlt } from 'react-icons/fa';
import videonothing from '../../assets/saynothing_female.mp4';
import video3 from '../../assets/page3_female_openai.mp4';
import video3_data from '../../assets/page3_female_openai_data.mp4';
import video3_v2 from '../../assets/page3_female_openai_v2.mp4';

const simliClient = new SimliClient();

const CampaignInitialize2 = () => {
  const [isPageReady, setIsPageReady] = useState(false);
  const [isLinkedInLoggedIn, setIsLinkedInLoggedIn] = useState(() => {
    const lnkActValue = localStorage.getItem('lnk_act');
    return lnkActValue === 'true' ? true : false; // Default to false if not "true"
  });
  const [isMuted, setIsMuted] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const navigate = useNavigate();
  const roboman_api = process.env.REACT_APP_ROBOMAN_API;
  const preRecordedRef = useRef(null);
  const audioRef = useRef(null);
  const videoRef = useRef(null);




  const Button = ({ className, onClick, text }) => (
    <button className={className} onClick={onClick}>
      {text}
    </button>
  );

  const {
    startListening,
    stopListening,
    getTranscript,
    isListening,
    browserSupportsSpeechRecognition,
    resetTranscript,
  } = useVoiceInput();

  const videoToUse =
    JSON.parse(localStorage.getItem('havedata')) === true ? video3_v2 : video3_v2;
  const [showPreRecorded, setShowPreRecorded] = useState(true);
  const [enableButton, setEnableButton] = useState(false);
  const [enableReload, setEnableReload] = useState(false);

  const handleStartSimli = async () => {
    const SimliConfig = {
      apiKey: process.env.REACT_APP_SIMLI_API_KEY,
      faceID: process.env.REACT_APP_SIMLI_FACEID_FEMALE,
      handleSilence: true,
      maxSessionLength: 1800, // in seconds
      maxIdleTime: 200, // in seconds
      videoRef: videoRef,
      audioRef: audioRef,
      SimliURL: "s://api.simli.ai",
    };

    try {
      simliClient.Initialize(SimliConfig);
      console.log("Simli Client initialized");

      await simliClient.start();
      console.log("WebRTC started");

      setTimeout(async () => {
        const audioData = new Uint8Array(1000).fill(0);
        simliClient.sendAudioData(audioData);
      }, 4000);
    } catch (error) {
      console.error("Error in handleVoiceMode:", error);
    }
  };

  const handleCloseSimli = () => {
    // Close the Simli Client connection
    simliClient.close();
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      const headers = {
        accept: 'application/json',
        Authorization: localStorage.getItem('access_token'),
      };

      try {
        const response = await fetch(`${roboman_api}/users/me`, {
          method: 'GET',
          headers: headers,
        });

        if (response.ok) {
          const data = await response.json();
          if (data.unipile_linkedin_id === null) {
            setIsLinkedInLoggedIn(false);
          } else {
            setIsLinkedInLoggedIn(true);
          }
        } else {
          localStorage.setItem('lnk_act', false);
          setIsLinkedInLoggedIn(false);
        }
      } catch (error) {
        localStorage.setItem('lnk_act', false);
        setIsLinkedInLoggedIn(false);
      } finally {
        setIsPageReady(true);
      }
    };

    if (isPageReady === false) fetchUserDetails();
  }, []);

  useEffect(() => {
    if (isPageReady) {
      handleStartSimli();
    }
  }, [isPageReady]);

  const HandleUsingCampaignAssistance = () => {
    handleCloseSimli();
    console.log("Using Campaign Assistance");
    navigate('/useraichat');
  };

  const HandleUsingManualFill = () => {
    handleCloseSimli();
    console.log("Using Manual Fill");
    navigate('/campfill');
  };

  const HandleBack = () => {
    handleCloseSimli();
    navigate('/dashboard');
  };

  const PlanOption = ({ title, features, onChoose, enableButton }) => (
    // Plan Option Component (design updated)
    <div className="w-full h-full rounded-2xl border border-slate-200 bg-white shadow-md flex flex-col p-4">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-md font-semibold text-slate-900">{title}</h3>
          <p className="text-[11px] text-slate-400 mt-0.5">
            {title === 'Campaign Assistant'
              ? 'Guided, conversational setup'
              : 'Manual, form-based setup'}
          </p>
        </div>
      </div>
      <div className="flex-1 rounded-xl bg-slate-50 border border-slate-100 p-3 text-xs text-slate-700">
        {Array.isArray(features) ? (
          <ul className="list-disc pl-4 space-y-1">
            {features.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <p>{features}</p>
        )}
      </div>
      <div className="mt-4 flex justify-end">
        <Button
          onClick={onChoose}
          className="min-w-[110px] py-2 px-4 text-xs font-semibold rounded-full bg-gradient-to-r from-[#223F9E] via-indigo-600 to-violet-500 text-white shadow-md hover:brightness-110 transition-all"
          text="Choose"
        />
      </div>
    </div>
  );

  const SelectionBox = ({ enableButton, reloadButton }) => {
    // Selection Box Component
    const plans = [
      {
        title: 'Campaign Assistant',
        features: ['Have a chat with Anna and she will create your campaign for you'],
        onChoose: HandleUsingCampaignAssistance,
      },
      {
        title: 'Manual Fill',
        features: [
          'Enter campaign details manually. Please fill out the following forms so we can build your campaign',
        ],
        onChoose: HandleUsingManualFill,
      },
    ];

    const handleReload = () => {
      window.location.reload(); // Reload the page
    };
    const [isMuted, setIsMuted] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

   
    return (
      <main className="w-full max-w-xl flex flex-col rounded-2xl border border-slate-200 bg-white shadow-[0_18px_50px_rgba(15,23,42,0.12)] px-5 py-6">
        <div className="flex flex-col gap-2 mb-5">
          <h1 className="text-lg md:text-xl font-semibold font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800  bg-clip-text text-transparent">
            Tell us about your situation
          </h1>
          <p className="text-xs text-slate-500">
            Choose whether you want Anna to guide you in a conversation, or you prefer filling out
            campaign details yourself.
          </p>
        </div>

        <div className="min-h-[260px] text-sm grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
          {plans.map((plan, index) => (
            <PlanOption
              key={index}
              title={plan.title}
              features={plan.features}
              onChoose={plan.onChoose}
              enableButton={enableButton}
            />
          ))}
        </div>

        <div className="flex items-center justify-between w-full mt-1">
          {/* Skip button on the left */}
          <Button
            onClick={HandleBack}
            className="h-[40px] min-w-[120px] text-xs font-semibold text-red-600 bg-white border border-red-200 rounded-full px-5 hover:bg-red-50 transition-all"
            text="Skip for now"
          />

          {/* Reload + Mic controls on the right */}
          <div className="flex justify-end items-center">
            {/* Reload Button */}
            <button
              onClick={handleReload}
              disabled={!reloadButton}
              className={`flex items-center justify-center rounded-full px-4 py-2 text-xs font-semibold mx-2 border transition-all ${reloadButton
                  ? 'bg-slate-900 text-white border-slate-900 hover:brightness-110 shadow-md'
                  : 'bg-slate-100 text-slate-400 border-slate-200 cursor-not-allowed'
                }`}
            >
              <FaSyncAlt size={14} className="mr-2" />
              Reload
            </button>

            {/* Microphone Button */}
            <button
              className={`rounded-full p-3 text-white mx-2 shadow-md transition-colors ${isListening ? 'bg-red-500' : 'bg-slate-500'
                }`}
              disabled={isListening || isAvatarPlaying}
            >
              {isListening ? <FaMicrophone size={18} /> : <FaMicrophoneSlash size={18} />}
            </button>
          </div>
        </div>
      </main>
    );
  };

  // for chat function
  const [inputMessage, setInputMessage] = useState('');
  const [response, setResponse] = useState('');
  const [isAvatarPlaying, setAvatarPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

   const toggleMute = () => {
      setIsMuted(prev => !prev);

      // Mute audio element
      if (audioRef.current) {
        audioRef.current.muted = !audioRef.current.muted;
      }

      // Mute pre-recorded video if playing
      if (preRecordedRef.current && showPreRecorded) {
        preRecordedRef.current.muted = !preRecordedRef.current.muted;
      }

      // Mute simli video
      if (videoRef.current) {
        videoRef.current.muted = !videoRef.current.muted;
      }
    };

    const togglePause = () => {
      const newPausedState = !isPaused;
      setIsPaused(newPausedState);

      // Handle pre-recorded video
      if (preRecordedRef.current && showPreRecorded) {
        if (newPausedState) {
          preRecordedRef.current.pause();
        } else {
          preRecordedRef.current.play().catch(err => console.log('Play error:', err));
        }
      }

      // Handle simli video
      if (videoRef.current && !showPreRecorded) {
        if (newPausedState) {
          videoRef.current.pause();
        } else {
          videoRef.current.play().catch(err => console.log('Play error:', err));
        }
      }

      // Handle audio
      if (audioRef.current) {
        if (newPausedState) {
          audioRef.current.pause();
        } else {
          audioRef.current.play().catch(err => console.log('Play error:', err));
        }
      }
    };

  const handleSendMessage = async () => {
    if (isListening) {
      stopListening();
    }

    resetTranscript();

    try {
      const response = await fetch(`${roboman_api}/campaign/initiation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: localStorage.getItem('access_token'),
        },
        body: JSON.stringify({
          input_str: inputMessage,
        }),
      });
      let fullResponse = await response.text();
      setResponse(fullResponse);
      console.log('response: ', fullResponse);

      if (fullResponse.includes('Thank you for choosing Campaign Assistant')) {
        stopListening();
        HandleUsingCampaignAssistance();
      } else if (fullResponse.includes('Thank you for choosing Manual Fill')) {
        stopListening();
        HandleUsingManualFill();
      } else {
        await sendAudiotoSimli(fullResponse, false);
      }
    } catch (error) {
      console.log(error);
      console.error('Error:', error);
      let errorMessage = 'Sorry, I encountered an error. Please try again.';
      if (error.response) {
        errorMessage = `Server error. Please try again later.`;
      } else if (error.request) {
        errorMessage =
          'No response from the server. Please check your internet connection.';
      } else {
        errorMessage = 'An unexpected error occurred. Please try again.';
      }
    } finally {
      // setIsBotResponding(false);
    }
  };

  const sendAudiotoSimli = async (assistant, is_summary = true) => {
    try {
      const response = await fetch(`${roboman_api}/openai/text-to-speech`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: localStorage.getItem('access_token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          text_input: assistant,
          is_summary: is_summary,
        }),
      });

      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('receive audio link:', result.image_url);

      const audio8uintdata = await fetchAndReturnPCM16(result.image_url);
      console.log('audio data:', audio8uintdata);

      const chunkSize = 6000;
      for (let i = 0; i < audio8uintdata.length; i += chunkSize) {
        const chunk = audio8uintdata.slice(i, i + chunkSize);
        simliClient.sendAudioData(chunk);
      }
      setAvatarPlaying(true);
    } catch (error) {
      console.error(error.message);
    } finally {
      // setIsLoading(false);
    }
  };

  const [messageSent, setMessageSent] = useState(false);
  const transcriptTimeoutRef = useRef(null);

  const resetAutoSendTimeout = () => {
    if (transcriptTimeoutRef.current) {
      clearTimeout(transcriptTimeoutRef.current);
    }

    transcriptTimeoutRef.current = setTimeout(async () => {
      if (inputMessage && inputMessage.trim() !== '' && !messageSent) {
        try {
          await handleSendMessage(true);
          setMessageSent(true);
          console.log('Message sent');
        } catch (error) {
          console.error('Error in handleSendMessage:', error);
        }
      }
    }, 2500);
  };

  useEffect(() => {
    const transcript = getTranscript();
    console.log('New transcript:', transcript);
    console.log('Current inputMessage:', inputMessage);

    if (isListening) {
      if (transcript !== inputMessage) {
        console.log('Transcript changed, updating inputMessage');
        setInputMessage(transcript);
        setMessageSent(false);
      } else if (transcript === inputMessage && !messageSent) {
        console.log('Transcript matches inputMessage, setting timeout');
        resetAutoSendTimeout();
      }
    } else {
      if (transcript) {
        setInputMessage(transcript);
      }
    }
  }, [getTranscript, isListening, inputMessage, messageSent]);

  useEffect(() => {
    simliClient.on('connected', () => {
      console.log('SimliClient has connected!');
      stopListening();
    });

    simliClient.on('disconnected', () => {
      console.log('SimliClient has disconnected!');
      stopListening();
      setEnableReload(true);
    });

    simliClient.on('failed', () => {
      console.log('SimliClient has failed to connect!');
      setEnableReload(true);
      stopListening();
    });

    simliClient.on('speaking', () => {
      setAvatarPlaying(true);
      console.log('Avatar is speaking');
      stopListening();
    });

    simliClient.on('silent', () => {
      console.log('Avatar is silent');
      setAvatarPlaying(false);
      setIsLoading(false);
      setEnableButton(true);
      console.log('Pre Recorded', showPreRecorded);
      if (!showPreRecorded) {
        setTimeout(() => {
          startListening();
        }, 500);
      }
    });
  }, [showPreRecorded]);

  const handlePreRecordedEnd = () => {
    setShowPreRecorded(false);
    startListening();
  };

  // If the page isn't ready yet, show a loading indicator or nothing
  if (!isPageReady) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 relative">
      {/* Header section */}
      <HeaderMainPage />
      {!isPageReady ? (
        // Loading State UI (kept, though unreachable because of early return)
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
          <FaSpinner className="text-gray-600 text-4xl animate-spin" />
        </div>
      ) : (
        // Main Page Content
        <div className="flex flex-col items-center flex-grow pt-10 overflow-auto max-h-screen">
          <div className="flex flex-col lg:flex-row w-full max-w-5xl min-h-[520px] md:justify-between md:items-stretch gap-8 px-4">
            {/* Left Box - Avatar */}
            <div className="w-full lg:w-1/2 flex items-center justify-center">
              <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white shadow-md flex items-center justify-center px-4 py-6">
                <div className="relative w-full aspect-square max-w-[340px]">
                  <div>
                    <video
                      ref={preRecordedRef}
                      className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-500 rounded-full ${showPreRecorded ? 'z-10' : 'opacity-0'
                        }`}
                      onEnded={handlePreRecordedEnd}
                      autoPlay
                      playsInline
                    >
                      <source src={videoToUse} type="video/ogg" />
                    </video>
                  </div>
                  <div>
                    <video
                      ref={videoRef}
                      id="simli_video"
                      autoPlay
                      playsInline
                      className="w-full h-full object-cover rounded-full"
                    ></video>
                    <audio ref={audioRef} id="simli_audio" autoPlay></audio>
                    {/* Control buttons */}
                    <div className="absolute bottom-3  left-1/2 -translate-x-1/2 flex  gap-1 z-20">
                      {/* Mute button */}
                      <button
                        onClick={toggleMute}
                        className="bg-black/70 backdrop-blur-sm text-white p-2 rounded-full hover:bg-black/80 transition-all duration-150 active:scale-95 shadow-lg"
                        aria-label={isMuted ? "Unmute" : "Mute"}
                      >
                        {isMuted ? <HiVolumeOff size={18} /> : <HiVolumeUp size={18} />}
                      </button>

                      {/* Pause button */}
                      <button
                        onClick={togglePause}
                        className="bg-black/70 backdrop-blur-sm text-white p-2 rounded-full hover:bg-black/80 transition-all duration-150 active:scale-95 shadow-lg"
                        aria-label={isPaused ? "Play" : "Pause"}
                      >
                        {isPaused ? <FaPlay size={18} /> : <FaPause size={18} />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Box - Selection */}
            <div className="w-full lg:w-1/2 flex items-center justify-center">
              <SelectionBox enableButton={enableButton} reloadButton={enableReload} />
            </div>
          </div>

          {/* LinkedIn Status Message */}
          <div className="w-full flex justify-center mt-10 mb-5 px-4">
            <div
              className={`px-5 py-2.5 text-xs md:text-sm font-semibold rounded-full shadow-md border ${isLinkedInLoggedIn
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                  : 'bg-red-50 text-red-700 border-red-200'
                }`}
            >
              {isLinkedInLoggedIn
                ? 'The LinkedIn login is successful. You can use LinkedIn features.'
                : 'The LinkedIn login is not successful. You cannot use LinkedIn features.'}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignInitialize2;
